import React from "react";
import { Navigate } from "react-router-dom";

class NoMatch extends React.Component {
  render() {
    return (
      <Navigate
        to={{ pathname: "style", search: this.props.location.search }}
      />
    );
  }
}

export default NoMatch;
